// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disable[data-v-786f69b2]{opacity:.2;background-color:var(--color-background)}.menu-item[data-v-786f69b2]{padding:.5rem 1rem}.menu-content[data-v-786f69b2]{background-color:var(--color-surface)}", ""]);
// Exports
module.exports = exports;
